import { useMemo } from 'react';

import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';

import { useHouseholdWorkflowTrackersContext } from '../contexts/useHouseholdWorkflowTrackersContext';

export function useIsEntityWorkflowTrackerInProgress(
  entityId: string | null | undefined,
  kind: WorkflowTrackerKind
): boolean {
  const { trackers } = useHouseholdWorkflowTrackersContext();

  return useMemo(() => {
    if (!entityId) return false;

    return trackers.some(
      (tracker) =>
        tracker.entities?.some((entity) => entity.id === entityId) &&
        tracker.kind === kind &&
        tracker.status === WorkflowTrackerStatus.Started
    );
  }, [trackers, entityId, kind]);
}
